import React from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'react-flexbox-grid';
import FormItem from 'common/components/formItem/FormItem';
import { ReactComponent as TrashIcon } from 'assets/svg/trash_no_color.svg';
import { Controller, UseFormMethods } from 'react-hook-form';
import Label from 'common/components/label/Label';
import { CompanyDto } from 'api/companies/models/CompanyDto';
import styles from './SmsFormItem.module.scss';
import InputGroup from 'common/components/inputGroup/InputGroup';
import InputError from 'common/components/inputError/InputError';
import { DATE_FORMAT_DEFAUT } from 'Config';
import { FaCalendarAlt } from 'react-icons/fa';
import DateTimePickerControllerNew from 'common/components/dateTimePicker/DateTimePickerControllerNew';

type Props = {
    form: UseFormMethods<CompanyDto>;
    isDetails: boolean;
    onRemoveClick: () => void;
    index: number;
} & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

const SmsFormItem: React.FC<Props> = ({
    form,
    isDetails,
    onRemoveClick,
    index,
    ...props
}: Props) => {
    const { t } = useTranslation();
    const errors = (form.errors?.textMessagesPurchases || [])[index] || null;

    return (
        <div
            {...props}
            className={`${props.className || ''}`}
        >
            <Row>
                <Col xs={12} sm={12} lg={4}>
                    <FormItem>
                        <Label className={styles.label}>
                            {t('sms.number_sms')}*
                        </Label>
                        <Controller
                            render={({ value, onChange }) => {
                                return (
                                    <InputGroup
                                        style={{ textAlign: 'end' }}
                                        format={'integer'}
                                        placeholder={t('sms.number_sms')}
                                        text={'SMS'}
                                        value={value}
                                        onValueChange={onChange}
                                        disabled={isDetails}
                                    />
                                );
                            }}
                            rules={{ required: true }}
                            control={form.control}
                            name={`textMessagesPurchases[${index}].numberSms`}
                            defaultValue={form.getValues(`textMessagesPurchases[${index}].numberSms`)}
                        />
                        <InputError error={errors?.numberSms} />
                    </FormItem>
                </Col>
                <Col xs={12} sm={12} lg={4}>
                    <FormItem>
                        <Label className={styles.label}>
                            {t('sms.date_purchase')}*
                        </Label>
                        <DateTimePickerControllerNew
                            form={form}
                            dateFormat={DATE_FORMAT_DEFAUT}
                            placeholderText={t('sms.date_purchase')}
                            customInput={<InputGroup icon={<FaCalendarAlt />} />}
                            autoComplete='off'
                            disabled={isDetails}
                            name={`textMessagesPurchases[${index}].datePurchase`}
                            rules={{ required: true }}
                        />
                        <InputError error={errors?.datePurchase} />
                    </FormItem>
                </Col>
                {!isDetails && (
                    <Col xs={1} sm={1} lg={1} style={{ display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
                        <div className={styles.removeButton} onClick={onRemoveClick}>
                            <TrashIcon className={styles.removeIcon} />
                        </div>
                    </Col>
                )}
            </Row>
            <hr className={styles.hr} />
        </div>
    );
};

export default SmsFormItem;
